module.exports = __webpack_public_path__ + "static/media/7_Teatrino-min.db4423fd.jpg";